var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"section",staticStyle:{"min-height":"2em"},attrs:{"flat":"","color":"white"}},[_c('v-card-title',{staticClass:"pl-0"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._v(" "),(_vm.subtitle)?_c('v-card-text',{staticClass:"grey--text pl-0"},[_vm._v("\n    "+_vm._s(_vm.subtitle)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }